/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

export const DoppelteTeilnahmenOptionen = [
    "KEINEAKTION",
    "BENACHRICHTIGEN",
    "BLOCKIEREN",
] as const;

type DoppelteTeilnahmenOption = typeof DoppelteTeilnahmenOptionen[number];

export default DoppelteTeilnahmenOption;
